export const SessionContextName = "CoreReactTemplateDemoAppContext";

/**
 * Private helper method for sending a request to the API.
 * 
 * @param {String} url - the url endpoint
 * @param {Object} requestOptions - Any other options to send with the request. (ex. body)
 * 
 * @returns {Promise<Response>} A promise object which resolves with the response of the request.
 */
export const send = async function (url, requestOptions) {
   
    return fetch(url, requestOptions)
        .then(response => {

            if (response.status >= 400 && response.status < 600) {

                switch (response.status) {
                    case 400:
                    case 404:
                    case 500:
                         throw new Error("Your request could not be processed. Please try again later.");
                    case 401:
                        throw new Error("Unauthorized: Please log in again or check your credentials.");
                    default:
                        throw new Error(`Http ${response.status}`);
                }
            }

            return response;
        })
        .catch(err => {
            console.log(`Error attempting to call api with url ${url}: ${err}`);
            throw err;
        });
}

/**
 * Makes a request to the public API and returns the data as a JSON object 
 * 
 * @param {String} url - The relative url
 * @param {Object} requestOptions - Any request options optional
 * @returns {Promise<Object>} - The object returned from the api call or an empty object if the api call returns nothing
 */
export const apiCall = (url, requestOptions) => {
    const requestOptionsJson = {
        ...requestOptions,
        headers: {
            'Content-Type': 'application/json'
        },
    };
    return send(url, requestOptionsJson)
        .then(response => response.text()
            .then(text => text.length > 0 ? JSON.parse(text) : {}));
}

export const apiCallRaw = (url, requestOptions) => {
    return send(url, requestOptions)
        .then(response => response.text());
}

/**
 * Makes a request to the secured APIs and returns the data as a JSON object 
 * Get accessToken from sessionStorage
 * @param {String} url - The relative url
 * @param {Object} requestOptions - Any request options optional
 * @returns {Promise<Object>} - The object returned from the api call or an empty object if the api call returns nothing
 */
export const securedApiCall = (url, requestOptions) => {
    let sessionContext = sessionStorage.getItem(SessionContextName);
    if (sessionContext) {
        // Update context
        let user = JSON.parse(sessionContext);
        const requestOptionsSecured = {
            ...requestOptions,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.sbToken
            },
        };
        return send(url, requestOptionsSecured)
            .then(response => response.text()
                .then(text => text.length > 0 ? JSON.parse(text) : {}));
    } else {
        return null;
    }
}
